export const TOOL_DIRECTORY_EMAIL = 'sam.miller@240tutoring.com';

/** The directory is private while the tools are still being tested. */
export function canViewToolDirectory(email: string | null | undefined): boolean {
  return email?.trim().toLowerCase() === TOOL_DIRECTORY_EMAIL;
}
